
		export default class PageState{
			//模板生成============================================================================
			self:any = null;
			title: string = "";
			//============================================================================
      emotionListMap: any = {};// 风格Map
      allSpeakerIdMap: any = {};// 发音人相关初始map
      userSpeakerTypeMapList:any=[];//用户发音分类(常用/已购/收藏..)
		}